import { defineRecipe } from "@chakra-ui/react";

export const dialogHeaderRecipe = defineRecipe({
  base: {
    px: 6,
    py: 5,
    mb: 3,
    bg: "primary",
    color: "white",
    fontWeight: 600,
    fontSize: "1rem",
  },
});

export const dialogContentRecipe = defineRecipe({
  base: {
    borderRadius: 10,
    overflow: "hidden",
    mx: 3,
  },
});

export const simpleDialogContentRecipe = defineRecipe({
  base: {
    height: "auto",
    overflow: "hidden",
    bg: "transparent",
    boxShadow: "none",
  },
});

export const dialogBodyRecipe = defineRecipe({
  base: {
    fontSize: 16,
    lineHeight: 1.5,
  },
  variants: {
    visual: {
      withoutTitle: {
        pt: 5,
      },
    },
  },
});

export const simpleDialogHeaderRecipe = defineRecipe({
  base: {
    justifyContent: "space-between",
    gap: 3,
    p: 0,
    mb: 3,
    fontSize: "1rem",
  },
});

export const simpleDialogBodyRecipe = defineRecipe({
  base: {
    padding: 0,
    fontSize: 16,
    lineHeight: 1.5,
    bg: "transparent",
  },
});

export const simpleDialogPositionerRecipe = defineRecipe({
  base: {
    padding: 5,
  },
});

export const simpleDialogBackdropRecipe = defineRecipe({
  base: {
    bg: "rgba(0, 0, 0, .75)",
  },
});

export const simpleDialogCloseTriggerRecipe = defineRecipe({
  base: {
    position: "static",
    ml: "auto",
    color: "white",
  },
});

export const dialogFooterRecipe = defineRecipe({
  base: {
    py: 3,
  },
});
